import style from 'styled-components';

export const StyledCustomAlert = style.div``;
